<div class="shrink-0 border-t border-line/40 bg-bg px-4 py-3">
  <div class="mx-auto w-full max-w-[84rem]">
    <nav aria-label="Workspace" class="flex items-center justify-between gap-2 overflow-x-auto font-label text-ui-label font-bold uppercase tracking-ui-label text-muted">
      @for (tab of tabs(); track tab.route) {
        <a
          [routerLink]="tab.route"
          class="inline-flex shrink-0 items-center gap-2 whitespace-nowrap rounded-sm2 px-3 py-1 transition hover:bg-panel2 hover:text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-line2"
          [attr.aria-current]="isActive(tab) ? 'page' : null"
          [class.bg-panel2]="isActive(tab)"
          [class.text-white]="isActive(tab)"
          [class.shadow-insetline]="isActive(tab)"
          (click)="onTabClick()">
          @if (tab.icon) {
            <span class="grid size-3.5 shrink-0 place-items-center text-line2">
              <span class="iconify text-sm {{ tab.icon }}"></span>
            </span>
          }
          {{ tab.label }}
        </a>
      }
    </nav>
  </div>
</div>
